module.exports = __webpack_public_path__ + "static/media/ophos-mission.b4564c99.svg";